/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons Enhancements
Akhila  10/28/2022 3075154998 data manager ux changes
Guru Prasad  10/29/2022 3075154998 data manager Card styles UI changes
Rohini 10/31/2022 3075154998 added spacing between the fields and removed boostrap classnames
Raghu Arun Kumar 11/02/2022 3075154998 Responsive Alignment Fixes
Lalitha          11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Grid, TextField, Typography, FormHelperText} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import ConditionForm from './Condition/AddCondition';
import ConditionTable from './Condition/ConditionTable';
import {FILE_FORMATS} from '../../../../../constants/Lookup';
import {
  fetchFilter,
  ResetStatus as resetStatus,
  ResetMessage as resetMessage,
  getDropDownData,
  ResetFiltersRule as resetFiltersRule,
  getRecordCode,
} from '../../../../../redux/reducers/EnableFramework/Filter';
import {
  fetchFilterDropdownData,
  postDataManager,
  fetchBreCodeAndDescription,
  resetData,
} from '../../../../../redux/reducers/EnableFramework/DataManager';
import {
  fetchDropdownData,
} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getObject} from '../../../../../util/GetDropdownObject';
import AddIcon from '@material-ui/icons/Add';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const AddDataManager = ({
  setTabValue,
  filterCode,
  setFilterCode,
  setFilterCodeName,
  filterCodeName,
  isCopyRowData,
  setUsageState,
  code,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    filterDataStatus,
    successMsg,
    addFiltersStatus,
    errorMsg,
    isLoading,
    filterData,
    userMetrix,
  } = useSelector(({filter}) => filter);
  const {dropDownData} = useSelector(({filter}) => filter);
  const {dropDownData: fileTypeDropDown} = useSelector(({addMediaType}) => addMediaType);
  const {filterDropDownData, BreDropDownData, fetchedDataManager, saveDataManagerStatus} =
    useSelector(({dataManager}) => dataManager);

  const getInitialObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.code === option) {
          label = item;
        }
      });
    return label;
  };

  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getRecordCode());
    dispatch(fetchBreCodeAndDescription());
  }, []);
  useEffect(() => {
    dispatch(fetchDropdownData());
  }, []);
  useEffect(() => {
    filterCode && dispatch(fetchFilter(filterCode));
  }, [filterCode]);

  useEffect(() => {
    if (!code || saveDataManagerStatus === 200) {
      dispatch(resetData());
    }
  }, [code, saveDataManagerStatus]);

  const [filterOpen, setFilterOpen] = useState(false);
  const [ruleGroupSNo, setRuleGroupSNo] = useState(1);
  const [conditionData, setConditionData] = useState([]);
  const [isConditionEditMode, setIsConditionEditMode] = useState(false);
  const [conditionRowData, setConditionRowData] = useState('');
  const [conditionCode, setConditionCode] = useState('');
  const [deleteCondition, setDeleteCondition] = useState([]);
  const [reset, setReset] = useState(false);
  const [type, setType] = useState();

  const initialValues = {
    code: fetchedDataManager?.dmCode ? fetchedDataManager?.dmCode : '',
    fileName: fetchedDataManager?.fileName ? fetchedDataManager?.fileName : '',
    fileNameLogicBlock: fetchedDataManager?.fileNameLogicBlock ?
      getInitialObject(fetchedDataManager?.fileNameLogicBlock, BreDropDownData) :
      '',
    fileType: fetchedDataManager?.dmType ?
      getObject(fetchedDataManager?.dmType, FILE_FORMATS, fileTypeDropDown) :
      '',
    filter: fetchedDataManager?.filter ? fetchedDataManager?.filter : '',
    filterGroup: fetchedDataManager?.filterGroup ? fetchedDataManager?.filterGroup : '',
    description:
      fetchedDataManager && fetchedDataManager?.dmDescription ?
        fetchedDataManager?.dmDescription :
        '',
    recordType:
      fetchedDataManager && fetchedDataManager?.type ?
        getObject(fetchedDataManager.type, RECORD_TYPE, dropDownData) :
        '',
    buOwner: '',
    owner: '',
    // conditionArgument:
    //   filterData && filterData.conditionArgument ? filterData.conditionArgument : "",
  };

  const schema = Yup.object().shape({
    code: Yup.string()
      .required('Filter code is required')
      .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed'),
    description: Yup.string().required('Description is required'),
    buOwner: Yup.string().max(20, 'BU Owner cannot exceed 20 characters'),
    owner: Yup.string().max(20, 'Owner cannot exceed 20 characters'),
  });

  useEffect(() => {
    if (filterDataStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
        dispatch(resetStatus());
        dispatch(resetMessage());
      }, 2000);
    }
  }, [filterDataStatus]);

  useEffect(() => {
    if (addFiltersStatus === 200 && userMetrix === 'Yes') {
      setTimeout(() => {
        dispatch(resetFiltersRule());
      }, 2500);
    }
  }, [userMetrix, addFiltersStatus]);

  const handleConditionClose = () => {
    setFilterOpen(false);
    setIsConditionEditMode(false);
    setRuleGroupSNo(conditionData?.length);
    setConditionRowData({});
  };
  const recordTypeImport = [
    {
      valueCode: 'DI',
      value: 'DEMOGRAPHICS IN',
    },
    {
      valueCode: 'NB',
      value: 'NEW BUSINESS',
    },
    {
      valueCode: 'PI',
      value: 'PAYMENTS IN',
    },
    {
      valueCode: 'RI',
      value: 'RECONCILIATION IN',
    },
  ];

  const recordTypeExport = [
    {
      valueCode: 'PO',
      value: 'PAYMENTS OUT',
    },
    {
      valueCode: 'RO',
      value: 'RECONCILIATION OUT',
    },
    {
      valueCode: 'DO',
      value: 'DEMOGRAPHICS OUT',
    },
  ];
  useEffect(() => {
    if (Object.keys(filterData).length > 0) {
      const data = [...filterData?.integrationFilterConditions];
      const newData = data.map((i) => {
        const conditionList = {
          ...i,
          conditionId: i?.conditionId ? i?.conditionId : 0,
          operator: i?.operator ? i.operator : '',
          srcField: i?.srcField ? i.srcField : '',
          toField: i?.toField ? i.toField : '',
          dateFormat: i?.dateFormat ? i.dateFormat : '',
          sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : '',
        };

        return conditionList;
      });
      setConditionData(newData);
    }
  }, [filterData, reset]);

  const handleSubmit = (values) => {
    const postData = {
      dataManagerId: values?.dataManagerId ? values?.dataManagerId : 0,
      dmCode: values?.code ? values?.code : '',
      dmDescription: values?.description ? values?.description : '',
      dmType: values?.fileType?.valueCode ? values?.fileType?.valueCode : '',
      fileName: values?.fileName ? values?.fileName : '',
      fileNameLogicBlock: values?.fileNameLogicBlock?.code ? values?.fileNameLogicBlock?.code : '',
      filterCode: values?.filter ? values?.filter : '',
      filterGroupCode: values?.filter ? values?.filter : '',
    };
    // setOverRiding(postData);
    dispatch(postDataManager(postData));
  };
  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading || successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setTabValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
          Search Data Manager
        </Button>
      </div>
      <div>
        <Formik
          onSubmit={(values, {validate}) => {
            handleSubmit(values);
            validate(values);
          }}
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;
            return (
              <div className={` mb-0`}>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <Grid container spacing={2}>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Code"
                          label="Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="code"
                          value={values?.code?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.code && errors.code}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Description`}
                          label="Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.description && errors.description}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="fileType"
                          options={getOptions(FILE_FORMATS, fileTypeDropDown)}
                          size="small"
                          autoHighlight
                          name="fileType"
                          value={values?.fileType}
                          getOptionDisabled={(option) => option?.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value ?
                                  option.value :
                                  '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('fileType', value);
                            setType(value);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              label="File Type"
                              name="fileType"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              placeholder="Select File Type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="recordType"
                          id="recordType"
                          size="small"
                          value={values.recordType}
                          options={
                            values?.fileType?.valueCode === 'I' ?
                              recordTypeImport :
                              values?.fileType?.valueCode === 'E' ?
                                recordTypeExport :
                                []
                          }
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value ?
                                  option.value :
                                  '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('recordType', value);
                            value?.valueCode && dispatch(fetchFilterDropdownData(value?.valueCode));
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.recordType && errors.recordType}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Record Type"
                                placeholder="Select Record Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>

                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          {...props}
                          id="filter"
                          options={filterDropDownData?.length > 0 ? filterDropDownData : []}
                          size="small"
                          autoHighlight
                          disabled={values?.filterGroup}
                          getOptionDisabled={(option) => option.filterCode === null}
                          getOptionLabel={(option) => {
                            return option && option?.filterCode && option?.filterName ?
                              option.filterCode + ' - ' + option.filterName :
                              option?.filterName === null ?
                                option?.filterCode :
                                '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('filter', value);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              disabled={values?.filterGroup}
                              placeholder={`Select Filter`}
                              label="Filter"
                              name="filter"
                              touched={touched.filter}
                              error={Boolean(touched.filter && errors.filter)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.filter && errors.filter}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          {...props}
                          id="filterGroup"
                          options={[]}
                          size="small"
                          autoHighlight
                          disabled={values?.filter}
                          getOptionDisabled={(option) => option.filterCode === null}
                          getOptionLabel={(option) => {
                            return option && option?.filterCode && option?.filterName ?
                              option.filterCode + ' - ' + option.filterName :
                              option?.filterName === null ?
                                option?.filterCode :
                                '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('filterGroup', value);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              disabled={values?.filterGroup}
                              placeholder={`Select Filter Group`}
                              label="Filter Group"
                              name="filterGroup"
                              touched={touched.filterGroup}
                              error={Boolean(touched.filterGroup && errors.filterGroup)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.filterGroup && errors.filterGroup}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter File Name`}
                          label="File Name"
                          disabled={values?.fileNameLogicBlock}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="fileName"
                          value={values.fileName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.fileName}
                          error={Boolean(touched.fileName && errors.fileName)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.fileName && errors.fileName}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          {...props}
                          id="fileNameLogicBlock"
                          options={BreDropDownData?.length > 0 ? BreDropDownData : []}
                          size="small"
                          autoHighlight
                          value={values?.fileNameLogicBlock}
                          disabled={values?.fileName}
                          getOptionDisabled={(option) => option.code === null}
                          getOptionLabel={(option) => {
                            return option && option?.code && option?.description ?
                              option.code + ' - ' + option.description :
                              option?.description === null ?
                                option?.code :
                                '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('fileNameLogicBlock', value);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              placeholder={`Enter Logic Block`}
                              label="File Name Logic Block"
                              name="fileNameLogicBlock"
                              touched={touched.fileNameLogicBlock}
                              error={Boolean(
                                touched.fileNameLogicBlock && errors.fileNameLogicBlock,
                              )}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.fileNameLogicBlock && errors.fileNameLogicBlock}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Owner`}
                          label="Owner"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="owner"
                          value={values.owner}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.owner}
                          error={Boolean(touched.owner && errors.owner)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.owner && errors.owner}
                        </FormHelperText>
                      </Grid>
                      <Grid item lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter BU Owner`}
                          label="BU Owner"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="buOwner"
                          value={values.buOwner}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.buOwner}
                          error={Boolean(touched.buOwner && errors.buOwner)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.buOwner && errors.buOwner}
                        </FormHelperText>
                      </Grid>
                      {values?.fileType?.valueCode === 'I' ? (
                        <Grid item xs={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Error File Name`}
                            label="Error File Name"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="errorFileName"
                            value={values.errorFileName}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.errorFileName}
                            error={Boolean(touched.errorFileName && errors.errorFileName)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.errorFileName && errors.errorFileName && errors.errorFileName}
                          </FormHelperText>
                        </Grid>
                      ) : null}
                    </Grid>
                    <Grid>
                      <div>
                        <Grid item className={`border-rounded mb-4 px-2`}>
                          <div className="table-header table-card-header d-flex justify-content-between">
                            <Typography variant="h3">Data Manager Records: </Typography>
                            <Button
                              variant="outlined"
                              className={`search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                setFilterOpen(true);
                                const reqNo =
                                  conditionData?.length > 0 &&
                                  conditionData[conditionData?.length - 1]?.code ?
                                    Number(
                                      conditionData[conditionData?.length - 1].code.slice(1),
                                    ) + 1 :
                                    conditionData?.length + 1;
                                setRuleGroupSNo(reqNo);
                              }}
                            >
                              <AddIcon />
                              Add Record
                            </Button>
                          </div>
                          <ConditionTable
                            conditionData={conditionData}
                            setConditionData={setConditionData}
                            setIsConditionEditMode={setIsConditionEditMode}
                            setConditionRowData={setConditionRowData}
                            setConditionCode={setConditionCode}
                            setDeleteCondition={setDeleteCondition}
                            deleteCondition={deleteCondition}
                            ruleGroupSNo={ruleGroupSNo}
                          />
                        </Grid>
                        {/* <Grid item xs={4} xl={6} md={6} sm={6} className="px-1 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Condition Argument`}
                          label="Condition Argument"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="conditionArgument"
                          value={values.conditionArgument}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required={conditionData?.length > 0}
                          touched={touched.conditionArgument}
                          error={Boolean(touched.conditionArgument && errors.conditionArgument)}
                        />
                        {conditionData?.length > 0 ? (
                          <FormHelperText style={{ color: "red" }}>
                            {errors.conditionArgument}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item className={`border-rounded mb-3 ${classes.cardBordernoneStyles}`}>
                        <div className="table-header">
                          <Typography variant="h3">Actions: </Typography>
                          <Button
                            variant="contained"
                            className={`themeing-buttons ${classes.buttonRoot}`}
                            onClick={() => setActionOpen(true)}
                          >
                            <AddIcon />
                            Add Action
                          </Button>
                        </div>
                        <ActionTable
                          actionData={actionData}
                          setActionData={setActionData}
                          setActionRowData={setActionRowData}
                          setIsEditMode={setIsEditMode}
                          setActionCode={setActionCode}
                          setDeleteAction={setDeleteAction}
                          deleteAction={deleteAction}
                        />
                      </Grid> */}
                      </div>
                    </Grid>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        if (!filterCode) {
                          setConditionData([]);
                          resetForm();
                          setType('');
                        } else {
                          resetForm();
                          setType('');
                          setReset(!reset);
                        }
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
        <DialogBox
          open={filterOpen || isConditionEditMode}
          dialogClose={handleConditionClose}
          title={'Add Record'}
          maxWidth="md"
        >
          <ConditionForm
            type={type}
            setConditionData={setConditionData}
            conditionData={conditionData}
            setFilterOpen={setFilterOpen}
            handleConditionClose={handleConditionClose}
            conditionRowData={conditionRowData}
            isConditionEditMode={isConditionEditMode}
            setIsConditionEditMode={setIsConditionEditMode}
            conditionCode={conditionCode}
            ruleGroupSNo={ruleGroupSNo}
          />
        </DialogBox>
        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </div>
  );
};

export default AddDataManager;
